import React, { useEffect, useState } from 'react'
import { CustomForm } from '../../../../../Components/Admin/CustomForm'
import { camposTransferir } from './listarPokemonesHelper'
import { useSelectUsuarios, useTransferirPokemon } from '../../../../../Hooks/Admin';
import { useDataUsuarioSelected } from '../../../../../Hooks/Admin/useContextos';
import { set } from 'react-hook-form';

export const ModalTransferirPokemon = ({ data, setRefetch, setModal }) => {
    const querySelectUsuarios = useSelectUsuarios({ idTius: 1 });
    const { selectedId } = useDataUsuarioSelected();

    const [idPokemon, setIdPokemon] = useState(null)

    useEffect(() => {
        if (data) {
            setIdPokemon(data.idPokemonCapturado)
        }
    }, [data])

    const modificaSubmit = (data) => {
        const dataForm = {
            ...data,
            idPokemonCapturado: idPokemon
        }

        return dataForm;
    }

    return (
        <>
            {
                idPokemon &&
                <CustomForm
                    name={'form-' + idPokemon}
                    camposFormulario={camposTransferir(querySelectUsuarios.data, selectedId, idPokemon)}
                    querySubmit={useTransferirPokemon}
                    setOpenModal={setModal}
                    tituloForm="Transferir Pokemon"
                    setRefetch={setRefetch}
                    modificaSubmit={modificaSubmit}
                />
            }
        </>
    )
}
